export default __webpack_public_path__ + "static/8-da573adfd1c1e94247fbf790efd7c3e2.jpg";